export default __webpack_public_path__ + "static/media/results_table_background.2964ea2e.svg";